import React, { useEffect } from 'react'
import { Box, Flex, Icon, styled, Text } from '@chilipiper/design-system'
import { SvgSandClock } from '@chilipiper/icons'
import { useTranslations } from '../../../context/TranslationContext'
import { chatPublicEventAction, chiliChatEventName } from '../../../constants'
import { BookingFlowMockBlock } from './BookingFlowMockBlock'

export const ExpiredBooking = () => {
  const [sessionExpired, sessionExpiredDescription] = useTranslations([
    'sessionExpired',
    'sessionExpiredDescription',
  ])

  useEffect(() => {
    window.dispatchEvent(
      new CustomEvent(chiliChatEventName, {
        detail: { action: chatPublicEventAction.NO_ACTION_CHOICE },
      })
    )
  }, [])

  return (
    <Box position='relative' minWidth={0} w='100%'>
      <Box
        position='absolute'
        zIndex={1}
        top={0}
        left={0}
        right={0}
        overflow='hidden'
        borderRadius={12}
        boxShadow='border/section'
        bg='bg/section'
        p={5}
        m={5}
      >
        <Flex gap={2} mb={3} alignItems='center'>
          <Icon icon={SvgSandClock} color='fg/minor' />
          <Text textStyle='page-section-heading' color='fg/major'>
            {sessionExpired ?? 'Session Expired'}
          </Text>
        </Flex>
        <Text textStyle='body-multiline' color='fg/moderate'>
          {sessionExpiredDescription ??
            'Your scheduling session has timed out due to inactivity, and the available times are no longer active.'}
        </Text>
      </Box>
      <StyledBlurBox inert={true}>
        <BookingFlowMockBlock />
      </StyledBlurBox>
    </Box>
  )
}

const StyledBlurBox = styled(Box)`
  filter: blur(3px);
`
